import React from 'react';
import { FormControlCheckbox } from './FormControlCheckbox.js';
import { FormControlInput } from './FormControlInput.js';
import { FormControlInputCopy } from './FormControlInputCopy.js';
import { FormControlMeta } from './FormControlMeta.js';
import { FormControlMultiselect } from './FormControlMultiselect.js';
import { FormControlRadioGroup } from './FormControlRadioGroup.js';
import { FormControlSelect } from './FormControlSelect.js';
import { FormControlTextarea } from './FormControlTextarea.js';
import { FormControlToggle } from './FormControlToggle.js';
import { HelperText } from './HelperText.js';
import { Label } from './Label.js';
export const FormControl = ({ children }) => (React.createElement("div", { className: "space-y-1" }, children));
FormControl.Label = Label;
FormControl.HelperText = HelperText;
FormControl.Meta = FormControlMeta;
FormControl.Input = FormControlInput;
FormControl.InputCopy = FormControlInputCopy;
FormControl.Checkbox = FormControlCheckbox;
FormControl.Textarea = FormControlTextarea;
FormControl.Toggle = FormControlToggle;
FormControl.Select = FormControlSelect;
FormControl.Multiselect = FormControlMultiselect;
FormControl.RadioGroup = FormControlRadioGroup;
//# sourceMappingURL=FormControl.js.map